import { styled } from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
`

export const Icon = styled.div`
  height: 24px;
  width: 24px;
  cursor: pointer;
  svg {
    :hover {
      fill: var(--dark-gray);
    }
    :active {
      fill: var(--orange);
    }
  }
`

export const TextInfo = styled.div`
  box-shadow: 0 0 20px hsl(0deg 0% 78% / 80%);
  position: absolute;
  top: 40px;
  width: 300px;
  ::before {
    content: '';
    border: 8px solid transparent;
    border-bottom-color: var(--white);
    bottom: 100%;
    position: absolute;
    right: 50%;
    transform: translateX(50%);
  }
  p {
    background-color: var(--white);
    box-sizing: border-box;
    font-family: var(--fontRegular);
    font-size: 14px;
    line-height: 17px;
    padding: 30px 20px;
  }
`
